<script lang="ts" setup>
import { Dayjs } from 'dayjs'
import { computed, onMounted, watch } from 'vue'

import { useStore } from '@/store'

import { ChartUnit, OptimizableStayStat, StatPercent } from './types'
import VolumeGraphics from './VolumeGraphics.vue'

const store = useStore()

const props = withDefaults(defineProps<{
  earlyLimit: Dayjs
  lateLimit: Dayjs
  chartUnit?: ChartUnit
  selectedMedicalUnits?: number[] | null
  labelSets: string[]
}>(), {
  chartUnit: ChartUnit.MONTH,
  selectedMedicalUnits: null,
})

const stats = computed<OptimizableStayStat[]>(() => store.state.stats.optimizableStaysStats)

const statsPercent = computed<StatPercent[]>(() => {
  return stats.value.map((s) => {
    return {
      prctRevaluableStay: s.countStay > 0 ? ((s.countTodoDasIaRevaluableStay / s.countStay) * 100.00).toFixed(2) : 0,
      prctOpenedStay: s.countStay > 0 ? ((s.countOptimizableOpenedStay / s.countStay) * 100.00).toFixed(2) : 0,
      prctValidatedStay: s.countStay > 0 ? ((s.countOptimizableValidatedStay / s.countStay) * 100.00).toFixed(2) : 0,
      prctEditedStay: s.countStay > 0 ? ((s.countOptimizableEditedStay / s.countStay) * 100.00).toFixed(2) : 0,
    }
  })
})

function refresh() {
  store.dispatch('getOptimizableStaysStats', {
    earlyLimit: props.earlyLimit.format('YYYY-MM-DD'),
    lateLimit: props.lateLimit.format('YYYY-MM-DD'),
    unit: props.chartUnit,
    medicalUnits: props.selectedMedicalUnits,
  })
}


watch([() => props.earlyLimit, () => props.lateLimit, () => props.chartUnit, () => props.selectedMedicalUnits], () => {
  refresh()
}, { immediate: true })
</script>

<template>
  <div class="stat">
    <h1 class="stat-title">
      Revalorisation
    </h1>
    <volume-graphics
      :label-sets="labelSets"
      :stats="stats"
      :stats-percent="statsPercent"
      :prct-infos="{
        prctRevaluableStay: { label: 'Revalorisables (DAS)', unit: '%' },
        prctOpenedStay: { label: 'Consultés', unit: '%' },
        prctEditedStay: { label: 'Validés (avec modification)', unit: '%' },
        prctValidatedStay: { label: 'Validés (total)', unit: '%' },
      }"
      :stats-infos="{
        countStay: { label: 'Optimisables', unit: 'séjour(s)' },
        countTodoDasIaRevaluableStay: { label: 'Revalorisables (DAS)', unit: 'séjour(s)'},
        countOptimizableOpenedStay: { label: 'Consultés', unit: 'séjour(s)' },
        countOptimizableValidatedStay: { label: 'Validés (total)', unit: 'séjour(s)' },
        countOptimizableEditedStay: { label: 'Revalorisés (avec modification)', unit: 'séjour(s)' },
      }"
    />
  </div>
</template>
